export default __webpack_public_path__ + "static/media/income_proj_02.c54c9b61.png";